/* global Sentry */ // https://github.com/octalmage/gatsby-plugin-sentry/issues/20

import React, { useEffect } from 'react'
import { Pagination, Autoplay } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/react'

import data from './data'

import CourierIcon from './assets/CourierIcon'

import 'swiper/css'
import 'swiper/css/autoplay'
import 'swiper/css/pagination'
import styles from './styles.module.scss'
import '../../../styles/_V2/components/swiper.scss'

import pro from '../../../pages-data/discounts/pro'
import { createCloud } from '../../../apiRequests/registration'
import { NetError } from '../../../apiRequests/utils'

function RegistrationFacts(props) {
  useEffect(() => {
    props.isCloudCreated && (
      props.setStep(4)
    )
  }, [props.isCloudCreated])

  return (
    <section className={styles.registrationFacts}>
      <p className={styles.registrationFacts__label}>{data.label}</p>

      <CourierIcon />

      <Swiper
        className={styles.registrationFacts__slider}
        modules={[Pagination, Autoplay]}
        slidesPerView="auto"
        pagination={{
				  clickable: true,
        }}
        autoplay={{
				  delay: 10000,
				  disableOnInteraction: false,
        }}
        autoHeight
        spaceBetween={30}
      >
        {data.facts.map((fact, index) => (
          <SwiperSlide
            key={`fact-${index}`}
            className={styles.registrationFacts__sliderItem}
          >
            <p className={styles.registrationFacts__fact}>{fact}</p>
          </SwiperSlide>
        ))}
      </Swiper>
    </section>
  )
}

export default RegistrationFacts
